module.exports=﻿{
    "config": [
        {
            "persona": "_connected",
            "states": [ 
                {
                    "current": "tunnel-ctr-connected.beneficiaire",
                    "next": "tunnel-ctr-connected.recapitulatif",
                    "previous": null
                },
                {
                    "current": "tunnel-ctr-connected.recapitulatif",
                    "next": "tunnel-ctr-connected.confirmation",
                    "previous": "tunnel-ctr-connected.beneficiaire"
                },
                {
                    "current": "tunnel-ctr-connected.confirmation",
                    "next": null,
                    "previous": "tunnel-ctr-connected.recapitulatif"
                }
            ]
        },
        {
            "persona": "_defaults",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.persona",
                    "previous": null
                },
                {
                    "current": "tunnel-ctr.persona",
                    "next": null,
                    "previous": "tunnel-ctr-intro"
                }
            ]
        },
        {
            "persona": "Directeur",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.simulation",
                    "previous": null,
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation",
                    "next": null,
                    "previous": "tunnel-ctr-intro",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation-modification",
                    "next": null,
                    "previous": "tunnel-ctr.simulation",
                    "onlyConnectedUser": false
                },
            ]
        },
        {
            "persona": "Secrétaire",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.simulation",
                    "previous": null,
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation",
                    "next": null,
                    "previous": "tunnel-ctr-intro",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation-modification",
                    "next": null,
                    "previous": "tunnel-ctr.simulation",
                    "onlyConnectedUser": false
                },
            ]
        },
        {
            "persona": "Assistant",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.simulation",
                    "previous": null,
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation",
                    "next": null,
                    "previous": "tunnel-ctr-intro",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation-modification",
                    "next": null,
                    "previous": "tunnel-ctr.simulation",
                    "onlyConnectedUser": false
                },
            ]
        },
        {
            "persona": "Comptable",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.simulation",
                    "previous": null,
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation",
                    "next": null,
                    "previous": "tunnel-ctr-intro",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation-modification",
                    "next": null,
                    "previous": "tunnel-ctr.simulation",
                    "onlyConnectedUser": false
                },
            ]
        },
        {
            "persona": "Gérant",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.simulation",
                    "previous": null,
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation",
                    "next": null,
                    "previous": "tunnel-ctr-intro",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation-modification",
                    "next": null,
                    "previous": "tunnel-ctr.simulation",
                    "onlyConnectedUser": false
                },
            ]
        },
        {
            "persona": "Autre",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.simulation",
                    "previous": null,
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation",
                    "next": null,
                    "previous": "tunnel-ctr-intro",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation-modification",
                    "next": null,
                    "previous": "tunnel-ctr.simulation",
                    "onlyConnectedUser": false
                },
            ]
        }
    ]
}
